import {
  IServiceRequestIssue,
  TUseServiceRequestIssuesOptions,
} from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from '../constants';

export const useServiceRequestIssues = (
  filterOptions: TUseServiceRequestIssuesOptions
) => {
  const { entityType, entityId, status, serviceRequestId } = filterOptions;
  const query = new URLSearchParams();

  if (entityType) {
    query.append('entityType', entityType);
  }

  if (entityId) {
    query.append('entityId', entityId);
  }
  if (status) {
    query.append('status', status);
  }

  if (serviceRequestId) {
    query.append('serviceRequestId', serviceRequestId);
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { issues: IServiceRequestIssue[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `${API_BASE_PATH}/issues?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
};
